import React, { useEffect, useRef, useState } from 'react'
import { LikeProductItem } from '@shopby/shop-sdk'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { getLikeProducts } from '../../api/product'
import '../../css/Product.css'
import { Button } from '../Button'
import { useCommonContext } from '../provider/CommonProvider'
import MyshoppingProductHeader from './ProductHeader'
import ShoppingProductItem from './ProductItem'
import ShoppingProductListItem from './ProductListItem'
import { useAppContext } from '../provider/AppProvider'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
interface ItemType {
  title: string
  item?: any
}

export default function MyShoppingProductList({ title, item }: ItemType) {
  const [listItem, setListItem] = useState<LikeProductItem[]>([]) //상품 아이템
  const [type, setType] = useState<string>('thumb')
  const [page, setPage] = useState<number>(1) //현재 페이지
  const [submitWish, setSubmitWish] = useState<boolean>(false)
  const [popupClose, setPopupClose] = useState<boolean>(false)
  const [items, setItems] = useState<LikeProductItem[]>([])

  const obsRef = useRef(null) //observer Element
  const itemRef = useRef(null)
  const preventRef = useRef(true) //옵저버 중복 실행 방지
  const endRef = useRef(false) //모든 글 로드 확인
  const navigate = useNavigate()
  const location = useLocation()

  const { isAppView } = useAppContext()
  const { hasAccessToken } = useCommonContext()

  useEffect(() => {
    //옵저버 생성
    if (items) {
      const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 })
      if (obsRef.current) observer.observe(obsRef.current)
      return () => {
        observer.disconnect()
      }
    }
  }, [items, itemRef])

  const obsHandler = (entries: any) => {
    //옵저버 콜백함수
    const target = entries[0]
    if (!endRef.current && target.isIntersecting && preventRef.current) {
      //옵저버 중복 실행 방지
      preventRef.current = false //옵저버 중복 실행 방지
      setPage((prev) => prev + 1) //페이지 값 증가
    }
  }

  useEffect(() => {
    if (title === 'recent') {
      setListItem(item)
    } else if (title === 'likeList') {
      if (hasAccessToken) {
        getLikeProducts(1)
          .then((res) => {
            setItems(res.data.items)
            setListItem(res.data.items)
            setPage(1)
            endRef.current = false
          })
          .catch((err) => console.log(err))
      }
    }
  }, [type, item, submitWish])

  useEffect(() => {
    if (listItem) {
      const filteredItems = listItem.filter((el: any) => !el.displayCategoryNos.includes('787334'))
      setItems(filteredItems)
    }
  }, [listItem])

  // 최근 본 상품, 찜한 목록 페이지에서 padding 조정
  useEffect(() => {
    if (location.pathname.includes('recentView') || location.pathname.includes('wishList')) {
      const productListWrap = document.querySelector('.product_list_wrap')
      productListWrap?.classList.add('padding_init')
    }
  }, [location.pathname])

  return (
    <>
      {listItem.length !== 0 ? (
        <>
          <div className='product_list_wrap'>
            {/* 상품목록 header */}
            {popupClose || title !== 'likeList' ? null : (
              <BluePopupWrap>
                <BlueContent>장바구니에 담고 적립금 적용가를 확인해보세요.</BlueContent>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px',
                  }}
                  onClick={() => {
                    setPopupClose((prev: boolean) => !prev)
                  }}
                >
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g clipPath='url(#clip0_149_809)'>
                      <path
                        d='M6 6L18 18M18 6L6 18'
                        stroke='var(--colWhite)'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_149_809'>
                        <rect width='24' height='24' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </BluePopupWrap>
            )}
            {title === 'recent' ? (
              <MyshoppingProductHeader
                totalCount={items.length}
                type={type}
                setType={setType}
              ></MyshoppingProductHeader>
            ) : (
              <MyshoppingProductHeader
                totalCount={items.length}
                type={type}
                setType={setType}
              ></MyshoppingProductHeader>
            )}

            {/* 상품 Item Wrap */}
            <div className={type === 'thumb' ? 'product_wrap' : 'product_wrap list'}>
              {type === 'thumb'
                ? items.map((el: any) => {
                    return (
                      <div ref={itemRef} key={el.productNo}>
                        <ShoppingProductItem item={el} setSubmitWish={setSubmitWish} items={item} />
                      </div>
                    )
                  })
                : null}
              {type === 'list'
                ? items.map((el: any) => {
                    return (
                      <div ref={itemRef} key={el.productNo}>
                        <ShoppingProductListItem
                          item={el}
                          key={el.productNo}
                          setSubmitWish={setSubmitWish}
                          items={item}
                        />
                      </div>
                    )
                  })
                : null}
            </div>
          </div>
          <div ref={obsRef} style={{ height: '20px' }}></div>
        </>
      ) : (
        <>
          <NoContentWrap>
            <MyshoppingProductHeader
              totalCount={listItem.length}
              type={type}
              setType={setType}
            ></MyshoppingProductHeader>
            <NoContentContentWrap>
              <NoContentTitle>
                {location.pathname.includes('recentView') ? '최근 본 상품이 없습니다.' : '찜한 목록에 상품이 없습니다.'}
              </NoContentTitle>
              <NoContentBtn
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.onClose, {
                      eventType: 999,
                    })
                  } else {
                    navigate('/')
                  }
                }}
              >
                쇼핑 계속하기
              </NoContentBtn>
            </NoContentContentWrap>
          </NoContentWrap>
        </>
      )}
    </>
  )
}

export const BluePopupWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  background: var(--colPointBlue);
  border-radius: 4px;
  margin: 8px 0;
`

export const BlueContent = styled.p`
  color: var(--colWhite);
  font-size: 14px;
  line-height: 18px;
  padding: 11px 12px;
  font-weight: 600;
`

export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 20px;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: 0;
  }
`

export const NoContentContentWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 120px 0;
  gap: 20px;
  @media screen and (min-width: 768px) {
    padding: 140px 0;
    gap: 32px;
  }
`

export const NoContentTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`

export const NoContentBtn = styled(Button)`
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 35px;
  color: var(--colWhite);
  background: var(--colBlack);
  border-radius: 76px;
  line-height: 20px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 14px 40px;
    cursor: pointer;
  }
`
